<template lang="pug">
  div.info
    figure
      img(:src="'./static/thumb/TS4560E.jpg'")
    div.spec
      div.name sadsa
      div.price 0000円
      dl.width
        dt 横幅
        dd 0000mm
      dl.height
        dt 高さ
        dd 0000mm
      dl.depth
        dt 奥行
        dd 0000mm
    <!--figure-->
      <!--img(:src="'./static/thumb/' + item.code + '.jpg'")-->
    <!--div.spec-->
      <!--div.name {{ item.name }}-->
      <!--div.price {{ item.price }}円-->
      <!--dl.width(v-if="check(item.w)")-->
        <!--dt 横幅-->
        <!--dd {{ item.w }}mm-->
      <!--dl.height(v-if="check(item.h)")-->
        <!--dt 高さ-->
        <!--dd {{ item.h }}mm-->
      <!--dl.depth(v-if="check(item.d)")-->
        <!--dt 奥行-->
        <!--dd  {{ item.d }}mm-->
  </template>

<script>
export default {
  name: 'info'
};
</script>

<style lang="stylus" scoped>
  .info
    color #ffffff
    background-color #00000088
    padding 8px
    border-radius 5px
    /*position absolute*/
    position fixed
    left 160px
    top 0
    display none
    z-index 100
    transform translate(0, -50%)
    figure
      width 120px
      overflow hidden
      img
        width 100%
    .spec
      padding 0 0 0 10px
      .name
        font-weight bold
        font-size 14px
      div,dl
        font-weight bold
        font-size 13px
      .price
        text-align right
      dl
        display flex
        justify-content space-between
</style>



// WEBPACK FOOTER //
// src/components/sidemenu/Info.vue